<app-main-wrapper>
  <div class="options-container">
    <div class="page-header">
      <h1 class="page-title">Settings</h1>
    </div>

    <div class="content" *ngIf="!isLoading">
      <form [formGroup]="optionsForm">

        <!-- Notetaker Mode Section -->
        <div class="section notetaker-section">
          <div class="section-title-row">
            <h2>Notetaker mode</h2>
          </div>
          <p class="description">
            When enabled, convverse joins your meetings as a notetaker to capture and summarize the conversation.
          </p>
          <div class="crm-option-row">
            <div class="option-title-wrap">
              <span class="option-label">Enable notetaker</span>
            </div>
            <label class="auto-sync-switch" for="notetakerModeToggle">
              <input id="notetakerModeToggle" type="checkbox" formControlName="notetakerMode" />
              <span class="switch-slider"></span>
            </label>
          </div>
        </div>

        <!-- License Section -->


        <!-- CRM Integration Section -->

        <div class="section crm-section" id="connect-crm-section" [class.attention-required]="!isAnyCrmConnected()">
          <div class="section-title-row">
            <h2>
              Connect to CRM
              <span class="attention-badge" *ngIf="!isAnyCrmConnected()">!</span>
            </h2>
            <div class="save-indicator">
              <span class="save-icon saving" *ngIf="saveState === 'saving'">
                <span class="loading-dots"><span></span><span></span><span></span></span>
              </span>
              <span class="save-icon saved" *ngIf="saveState === 'saved'">
                <i class="fa-solid fa-check"></i> Saved
              </span>
            </div>
          </div>
          <p class="description">
            Choose your CRM provider and configure how meeting updates are pushed.
          </p>

          <div class="crm-grid">
            <div class="crm-item crm-salesforce" [class.crm-locked]="isCrmLocked('salesforce')">
              <div class="crm-item-header">
                <div class="crm-brand">
                  <span class="crm-logo crm-logo-salesforce" aria-hidden="true">
                    <i class="fa-brands fa-salesforce"></i>
                  </span>
                  <span class="crm-title">Salesforce</span>
                </div>
              </div>
              <button
                *ngIf="!isCrmConnected('salesforce')"
                type="button"
                class="crm-connect-btn salesforce-btn"
                [class.connected]="isCrmConnected('salesforce')"
                [class.crm-disabled]="isCrmConnectDisabled('salesforce')"
                [disabled]="isCrmConnectDisabled('salesforce')"
                (click)="connectCrm('salesforce')"
              >
                {{ getCrmConnectButtonLabel('salesforce') }}
              </button>
              <button
                *ngIf="isCrmConnected('salesforce')"
                type="button"
                class="crm-disconnect-btn"
                [disabled]="isCrmActionLoading"
                (click)="disconnectCrm('salesforce')"
              >
                {{ getCrmDisconnectButtonLabel('salesforce') }}
              </button>
            </div>

            <div class="crm-item crm-zoho" [class.crm-locked]="isCrmLocked('zoho')">
              <div class="crm-item-header">
                <div class="crm-brand">
                  <span class="crm-logo crm-logo-zoho" aria-hidden="true">
                    <span class="zoho-logo-icon"></span>
                  </span>
                  <span class="crm-title">Zoho</span>
                </div>
              </div>
              <button
                *ngIf="!isCrmConnected('zoho')"
                type="button"
                class="crm-connect-btn zoho-btn"
                [class.connected]="isCrmConnected('zoho')"
                [class.crm-disabled]="isCrmConnectDisabled('zoho')"
                [disabled]="isCrmConnectDisabled('zoho')"
                (click)="connectCrm('zoho')"
              >
                {{ getCrmConnectButtonLabel('zoho') }}
              </button>
              <button
                *ngIf="isCrmConnected('zoho')"
                type="button"
                class="crm-disconnect-btn"
                [disabled]="isCrmActionLoading"
                (click)="disconnectCrm('zoho')"
              >
                {{ getCrmDisconnectButtonLabel('zoho') }}
              </button>
            </div>

            <div class="crm-item crm-hubspot" [class.crm-locked]="isCrmLocked('hubspot')">
              <div class="crm-item-header">
                <div class="crm-brand">
                  <span class="crm-logo crm-logo-hubspot" aria-hidden="true">
                    <i class="fa-brands fa-hubspot"></i>
                  </span>
                  <span class="crm-title">HubSpot</span>
                </div>
              </div>
              <button
                *ngIf="!isCrmConnected('hubspot')"
                type="button"
                class="crm-connect-btn hubspot-btn"
                [class.connected]="isCrmConnected('hubspot')"
                [class.crm-disabled]="isCrmConnectDisabled('hubspot')"
                [disabled]="isCrmConnectDisabled('hubspot')"
                (click)="connectCrm('hubspot')"
              >
                {{ getCrmConnectButtonLabel('hubspot') }}
              </button>
              <button
                *ngIf="isCrmConnected('hubspot')"
                type="button"
                class="crm-disconnect-btn"
                [disabled]="isCrmActionLoading"
                (click)="disconnectCrm('hubspot')"
              >
                {{ getCrmDisconnectButtonLabel('hubspot') }}
              </button>
            </div>

            <!-- Pipedrive — Coming soon -->
            <div class="crm-item crm-pipedrive crm-item--disabled">
              <div class="crm-item-header">
                <div class="crm-brand">
                  <span class="crm-logo crm-logo-pipedrive" aria-hidden="true">
                    <span class="pipedrive-logo-icon"></span>
                  </span>
                  <span class="crm-title">Pipedrive</span>
                </div>
              </div>
              <button type="button" class="crm-connect-btn pipedrive-btn" disabled>Coming soon</button>
            </div>
            <!--
            <div class="crm-item crm-pipedrive" [class.crm-locked]="isCrmLocked('pipedrive')">
              <div class="crm-item-header">
                <div class="crm-brand">
                  <span class="crm-logo crm-logo-pipedrive" aria-hidden="true">
                    <span class="pipedrive-logo-icon"></span>
                  </span>
                  <span class="crm-title">Pipedrive</span>
                </div>
              </div>
              <button
                *ngIf="!isCrmConnected('pipedrive')"
                type="button"
                class="crm-connect-btn pipedrive-btn"
                [class.connected]="isCrmConnected('pipedrive')"
                [class.crm-disabled]="isCrmConnectDisabled('pipedrive')"
                [disabled]="isCrmConnectDisabled('pipedrive')"
                (click)="connectCrm('pipedrive')"
              >
                {{ getCrmConnectButtonLabel('pipedrive') }}
              </button>
              <button
                *ngIf="isCrmConnected('pipedrive')"
                type="button"
                class="crm-disconnect-btn"
                [disabled]="isCrmActionLoading"
                (click)="disconnectCrm('pipedrive')"
              >
                {{ getCrmDisconnectButtonLabel('pipedrive') }}
              </button>
            </div>
            -->
          </div>

          <div class="crm-options">
            <div class="crm-option-row">
              <div class="option-title-wrap">
                <span class="option-label">Push mode</span>
                <button
                  type="button"
                  class="info-btn"
                  aria-label="Push mode help"
                  title="Select where updates should be created in your CRM: Notes for context logs or Tasks for actionable follow-ups."
                >
                  ?
                </button>
              </div>

              <div class="push-mode-group" role="radiogroup" aria-label="CRM push mode">
                <label class="push-mode-option">
                  <input type="radio" name="crmPushMode" formControlName="pushMode" value="notes" />
                  <span>Notes</span>
                </label>
                <label class="push-mode-option">
                  <input type="radio" name="crmPushMode" formControlName="pushMode" value="tasks" />
                  <span>Tasks</span>
                </label>
              </div>
            </div>

            <div class="crm-option-row">
              <div class="option-title-wrap">
                <span class="option-label">Auto sync</span>
                <button
                  type="button"
                  class="info-btn"
                  aria-label="Auto sync help"
                  title="When enabled, new meeting data is pushed automatically to your CRM without manual action."
                >
                  ?
                </button>
              </div>

              <label class="auto-sync-switch" for="crmAutoSyncToggle">
                <input id="crmAutoSyncToggle" type="checkbox" formControlName="autoSync" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
        
        <!-- Ignored Domains Section -->
        <div class="section">
          <div class="section-title-row">
            <h2>Ignored domains</h2>
            <div class="save-indicator">
              <span class="save-icon saving" *ngIf="saveState === 'saving'">
                <span class="loading-dots"><span></span><span></span><span></span></span>
              </span>
              <span class="save-icon saved" *ngIf="saveState === 'saved'">
                <i class="fa-solid fa-check"></i> Saved
              </span>
            </div>
          </div>
          <p class="description">
            Add domains to classify meetings as internal. The bot won't join meetings with attendees from these domains.
          </p>
          
          <div class="domains-checklist">
            <!-- Existing Ignored Domains -->
            <div class="domain-checklist-item" *ngFor="let control of ignoredDomainsArray.controls; let i = index" formArrayName="ignoredDomains">
              <label class="domain-checkbox-container">
                <input
                  type="text"
                  [formControlName]="i"
                  class="domain-input-edit"
                  placeholder="example.com"
                  (input)="onDomainChange()"
                />
                <button
                  type="button"
                  class="btn-remove-inline"
                  (click)="removeIgnoredDomainField(i)"
                >
                  ✕
                </button>
              </label>
            </div>

            <!-- Add Domain Input -->
            <div class="add-domain-section">
              <input
                type="text"
                [(ngModel)]="newIgnoredDomain"
                [ngModelOptions]="{standalone: true}"
                placeholder="Enter domain (e.g., company.com)"
                class="domain-input-add"
                (keyup.enter)="addNewIgnoredDomain()"
              />
              <button 
                type="button" 
                class="btn-add-inline" 
                (click)="addNewIgnoredDomain()"
                [disabled]="!newIgnoredDomain || !newIgnoredDomain.trim()"
              >
                <i class="fa-solid fa-plus"></i> Add
              </button>
            </div>
          </div>
        </div>



        

        <!-- License Section -->
        <div class="section license-section" id="license-section" *ngIf="licenseContext">
          <div class="license-section-header">
            <div>
              <h2>License & Plan</h2>
              <p class="description">Your current plan and access status.</p>
            </div>
            <a href="https://convverse.ai/contact-us" target="_blank" rel="noopener noreferrer"
               class="keep-convverse-btn"
               *ngIf="licenseContext.effective_license_state !== 'active' || (licenseContext.license_end && daysUntilExpiry !== null && daysUntilExpiry <= 7)">
              Keep Convverse →
            </a>
          </div>

          <div class="license-info-grid">
            <div class="license-info-item">
              <span class="li-label">Plan</span>
              <span class="li-value plan-badge" [class.plan-trial]="licenseContext.license_type === 'free_trial'" [class.plan-freemium]="licenseContext.license_type === 'freemium'" [class.plan-companion]="licenseContext.license_type === 'companion'" [class.plan-pro]="licenseContext.license_type === 'pro'" [class.plan-enterprise]="licenseContext.license_type === 'enterprise'">
                {{ planLabel }}
              </span>
            </div>
            <div class="license-info-item">
              <span class="li-label">Status</span>
              <span class="li-status" [class.status-active]="licenseContext.effective_license_state === 'active'" [class.status-grace]="licenseContext.effective_license_state === 'in_grace'" [class.status-expired]="licenseContext.effective_license_state === 'expired' || licenseContext.effective_license_state === 'none'" [class.status-suspended]="licenseContext.effective_license_state === 'suspended'">
                {{ licenseStatusLabel }}
              </span>
            </div>
            <div class="license-info-item" *ngIf="!isFreemium && licenseContext.license_end">
              <span class="li-label">{{ licenseContext.effective_license_state === 'active' ? 'Expires' : 'Expired' }}</span>
              <span class="li-value">{{ licenseEndFormatted }}</span>
            </div>
            <div class="license-info-item" *ngIf="!isFreemium && daysUntilExpiry !== null && licenseContext.effective_license_state === 'active'">
              <span class="li-label">Days remaining</span>
              <span class="li-value" [class.li-value--warning]="daysUntilExpiry <= 3">{{ daysUntilExpiry }} days</span>
            </div>
            <div class="license-info-item" *ngIf="organizationName">
              <span class="li-label">Organization</span>
              <span class="li-value org-name-badge">{{ organizationName }}</span>
            </div>
            <div class="license-info-item" *ngIf="licenseContext.organization_role">
              <span class="li-label">Role</span>
              <span class="li-value">{{ licenseContext.organization_role === 'organizational_admin' ? 'Admin' : 'Member' }}</span>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Loading State -->
    <div class="loading" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading settings...</p>
    </div>
  </div>
</app-main-wrapper>
